import { Grid, Modal } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Back,
  Button,
  ConfirmationPopup,
  ContractsTable,
  DatePicker,
  FileDropZone,
  PageTitleAndSubTitle,
  PlanDocs,
  ReportsSelectionTable,
  TabStepper,
  TypableDropdown,
  UploadedDocument,
  CardComponent,
  NoDataTable,
  // Trash,
  CustomTable,
  NoDataVisual,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  // Avatar,
  TextWithIcon,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React, { useEffect, useState } from 'react';
import InfoBar from '../../_components/atoms/InfoBar';
import { scrollBarStyles } from '../../core-utils/messages/CommonConstants';
import axios from 'axios';
import properties from '../../core-utils/properties';
import { useStores } from '../../stores';
import { observer } from 'mobx-react';
import contractAIQConstants from '../../core-utils/messages/ContractAIQConstants';
import Loader from '../../_components/molecules/Loader';
import {
  bytesToMB,
  extractCompareAgreementDetails,
  formatContractData,
  formatContractReports,
  formatMergeContractData,
  formatMergePlanDocsData,
  // formatMergePlanDocsData,
  // formatPlanDocsData,
  formatPlanDocsReports,
  formatReportsData,
  getCategoryByFeature,
} from '../../core-utils/helper-utils/contractAIQHelper';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  CONTRACT_AIQ_INTERNAL,
  PLAN_DOCUMENTS_INTERNAL,
  ONBOARDINGSTATUS,
} from '../../core-utils/routes';
import TabSelection from '../../_components/molecules/TabSelection';
import GifWithLabels from '@HomaHealth/ui-component-library/lib/_patient-access-components/molecules/GIFWithLabels';
import contract from '../../../public/Images/Contract.png';
import {
  convertToJSONString,
  extractAndSaveFees,
  extractAndSaveMetadataForContract,
  extractAndSaveProvisionMatrix,
  extractAndSaveProvisionMatrixData,
  extractAndSaveSummary,
  // getDefaultUrlsForServiceAgreement,
  getUrlsForServiceAgreement,
  // extractCustomMetadataFromContract,
  promptChain,
} from '../../core-utils/helper-utils/contractMetadataHelper';
import {
  createNamespace,
  extractPlanDocsReport,
  // createNamespace,
  extractReport,
} from '../../core-utils/helper-utils/contractReportHelper';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { Close } from '@HomaHealth/ui-component-library';
import {
  arrayToString,
  formatDate,
} from '../../core-utils/helper-utils/helper';
import AutocompleteWithCheckBoxes from '../../_components/atoms/Autocomplete';
import { CustomTableColumns } from '@HomaHealth/ui-component-library/lib/_AIQ-components/organisms/CustomTable';
import ContractsUploadTab from '../../_components/organisms/ContractsUploadTab';

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '1182px',
    padding: '40px 0px 66px 63px',
  },
  tabContent: { marginTop: '28px' },
  onboardingCards: {
    display: 'flex',
    gap: '24px',
  },
  groupDetails: {
    minWidth: '214px',
    background: patientAccessTheme.palette.status.white,
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderTop: 'none',
    borderRadius: '4px',
  },
  detail: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    borderTop: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    padding: '18px 16px 18px 20px',
  },
  stepsGrid: {
    background: patientAccessTheme.palette.status.white,
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderRadius: '4px',
    width: '100%',
  },
  contractsUpload: {
    padding: '25px 24px 28px 24px',
    height: '505px',
    position: 'relative',
  },
  uploadFilesGrid: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    marginBottom: '48px',
  },
  uploadedFiles: {
    height: '233px',
    width: '60%',
    background: patientAccessTheme.palette.background.default,
    borderRadius: '4px',
    padding: '18px 12px',
  },
  files: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    height: '136px',
    overflow: 'auto',
    paddingRight: '8px',
    ...scrollBarStyles,
  },
  contractLabels: {
    display: 'flex',
    marginBottom: '12px',
  },
  contractDocs: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    height: '308px',
    overflow: 'auto',
    paddingRight: '7px',
    ...scrollBarStyles,
  },
  contractsTable: {
    maxHeight: '336px',
    paddingRight: '4px',
    overflowY: 'auto',
    ...scrollBarStyles,
  },
  eachContractDoc: {
    display: 'flex',
    gap: '12px',
  },
  buttonsGrid: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    position: 'absolute',
    bottom: '24px',
    right: '24px',
  },
  completedState: {
    display: 'flex',
    alignItems: 'center',
    height: '505px',
    justifyContent: 'center',
    padding: '0px 200px',
  },
  tableHeader: {
    height: '48px',
    backgroundColor: patientAccessTheme.palette.grey[100],
    borderTop: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    '&:first-child': {
      paddingLeft: '38px',
    },
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  tableRow: {
    height: 'auto',
    minHeight: '56px',
    padding: '0px',
    borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    '& td:first-child': {
      paddingLeft: '26px',
    },
    '&:hover': {
      backgroundColor: patientAccessTheme.palette.grey[300],
    },
    display: 'flex',
    alignItems: 'center',
  },
  tableTHForRowTop: {
    height: '48px',
    backgroundColor: patientAccessTheme.palette.grey[100],
    borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
  },
  tableHeaderText: {
    fontWeight: 500,
    color: patientAccessTheme.palette.text.highemphasis,
    fontSize: '12px',
    lineHeight: '12px',
  },
  tableDataText: {
    fontSize: '14px',
    lineHeight: '24px',
    color: patientAccessTheme.palette.text.highemphasis,
    width: '244px',
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
  },
  mergeTable: {
    padding: '0px',
  },
  ellipses: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '165px',
    whiteSpace: 'nowrap',
    '&:hover': {
      overflow: 'visible',
      whiteSpace: 'normal',
      height: 'auto',
    },
  },
  uploadModal: {
    width: '800px',
    maxHeight: '720px',
    backgroundColor: patientAccessTheme.palette.status.white,
    borderRadius: '8px',
    padding: '24px 32px 20px 32px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    flexDirection: 'column',
  },
  clickableText: {
    textDecoration: `underline 2px dashed ${patientAccessTheme.palette.primary.main}`,
    textUnderlineOffset: '4px',
  },
});

export interface locationProps {
  state: {
    tabIndex: number;
  };
}

const ContractOnBoarding = observer(() => {
  //Constants
  const { classes } = useStyles();

  const complianceAssuranceStore = useStores().complianceAssuranceStore;
  const contractAiqStore = useStores().contractAiqStore;
  const employerGroupStore = useStores().employerGroupStore;
  const employer =
    employerGroupStore.employerGroupResponseData.employer_group_name[0];
  const egNid = employerGroupStore.employerGroupResponseData.eg_nid[0];
  // const groupId = complianceAssuranceStore.groupId;
  const messages = contractAIQConstants.COMPLIANCE_ASSURANCE;
  const navigate = useNavigate();
  const location: locationProps = useLocation();
  const planDocsButtonLabels = [
    'Upload Files',
    'Upload Plan Documents',
    'Add Reports',
    'Finish',
  ];
  const contractsButtonLabels = [
    'Upload Files',
    'Upload Contracts',
    'Add Reports',
    'Finish',
  ];
  const contractColumns = [
    'Healthcare Partner',
    'Service Type',
    'Document',
    'Status',
    'Action',
    '',
    '',
  ];

  const planDocColumns = [
    'Plan Type',
    'Benefit Types',
    'SOB/SPD',
    'Status',
    'Action',
    '',
    '',
  ];
  // const rowMenuItems = [
  //   {
  //     label: 'Delete',
  //     icon: <Trash />,
  //   },
  // ];
  // const subRowMenuItems = [
  //   {
  //     label: 'Delete Document',
  //     icon: <Trash />,
  //   },
  // ];

  const planDocsColumns: CustomTableColumns[] = [
    {
      header: 'Benefit Types',
      accessor: 'benefitTypes',
      cell: (value: any) => (
        <Grid>
          <Typography
            fontSize="14px"
            lineHeight="22.4px"
            fontType="medium"
            textColor={patientAccessTheme.palette.primary.main}
            cursor="pointer"
            className={classes.clickableText}
          >
            {arrayToString(value)}
          </Typography>
        </Grid>
      ),
    },
    {
      header: 'Document Type',
      accessor: 'docType',
      width: '200px',
    },
    {
      header: 'Plan Names',
      accessor: 'planNames',
      cell: (value: any) => <>{arrayToString(value)}</>,
    },
    {
      header: 'Vendors',
      accessor: 'vendors',
      cell: (value: any) => (
        <>{arrayToString(value?.map((item: any) => item?.vendor_name))}</>
      ),
    },
  ];

  //States
  const [activeStep, setActiveStep] = useState<number>(
    location?.state?.tabIndex ?? 0,
  );
  const [completedSteps, setCompletedSteps] = useState<number[]>([]);
  const [tabIndex, setTabIndex] = useState<number>(0);

  const [groupFieldsData, setGroupFieldsData] = useState({
    Group: '',
    'Claims Administrator': '',
    PBM: '',
    'Stop Loss Carrier': '',
    // 'Network Carrier': '',
    'Advisor/Broker': '',
  });
  const [isPlanDocsPopupOpen, setIsPlanDocsPopupOpen] = useState<boolean>(
    false,
  );
  const [loading, setLoading] = useState<boolean>(true);
  const [isMergeDocsPopupOpen, setIsMergeDocsPopupOpen] = useState<boolean>(
    false,
  );

  //Contracts Upload states
  const [contractStep, setContractStep] = useState<number>(0);
  const [
    isContractsButtonDisabled,
    setIsContractsButtonDisabled,
  ] = useState<boolean>(true);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);
  const [serviceAgreements, setServiceAgreements] = useState<any>([]);
  const [healthcarePartners, setHealthcarePartners] = useState<string[]>([]);
  const [contractLoading, setContractLoading] = useState<boolean>(false);
  const [uploadedDocuments, setUploadedDocuments] = useState<
    {
      document_name: string;
      document_id: string;
      document_type: string;
      document_effective_date: string;
      service_agreement_id: string;
      health_care_partner: string;
    }[]
  >([]);
  const [contractsTableData, setContractsTableData] = useState<any[]>([]);
  const [reportsTableData, setReportsTableData] = useState<any[]>([]);

  //PlanDocuments Upload states
  const [planDocsStep, setPlanDocsStep] = useState<number>(0);
  const [plansLoading, setPlansLoading] = useState<boolean>(false);
  const [
    isPlanDocsButtonDisabled,
    setIsPlanDocsButtonDisabled,
  ] = useState<boolean>(true);
  const [selectedPlanDocs, setSelectedPlanDocs] = useState<any>([]);

  const [planTypes, setPlanTypes] = useState<string[]>([]);
  const [uploadedPlanDocuments, setUploadedPlanDocuments] = useState<
    {
      document_name: string;
      document_id: string;
      document_type: string;
      document_sub_type: string;
      document_summary: string;
      benefit_types: string[];
      plan_names: string[];
      effective_date: string;
      benefits_match_reason?: string;
      sponsor_name?: string;
      vendors?: {
        vendor_name: string;
        vendor_type: string;
        match_reason: string;
      }[];
    }[]
  >([]);
  const [planNames, setPlanNames] = useState<any[]>([]);
  const [planDocsTableData, setPlanDocsTableData] = useState<any[]>([]);
  const [planDocsReportsTableData, setPlanDocsReportsTableData] = useState<
    any[]
  >([]);

  //Merge Documents States
  const [mergeContractsTableData, setMergeContractsTableData] = useState<any[]>(
    [],
  );
  const [
    contractsWithAmendmentsCount,
    setContractsWithAmendmentsCount,
  ] = useState<number>(0);

  const [mergePlanDocTableData, setMergePlanDocTableData] = useState<any[]>([]);
  const [
    planDocWithAmendmentsCount,

    setPlanDocWithAmendmentsCount,
  ] = useState<number>(0);
  const [uploadMasterDocPopUp, setUploadMasterDocPopUp] = useState<boolean>(
    false,
  );
  const [uploadedMasterDoc, setUploadedMasterDoc] = useState<any>([]);

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  //Functions
  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const checkAllFieldsFilled = (
    objectsArr: any[],
    excludeKeys: string[] = [],
  ) => {
    return objectsArr.every((obj: any) => {
      for (const key in obj) {
        if (
          obj.hasOwnProperty(key) &&
          !obj[key] &&
          !excludeKeys.includes(key)
        ) {
          return false;
        }
      }
      return true;
    });
  };

  //Contracts Onboard handlechange functions
  const handleChange = (event: any, fieldName: string, documentId: string) => {
    const value = event.target.value as string;
    setUploadedDocuments((prevDocuments) =>
      prevDocuments.map((doc) =>
        doc.document_id === documentId
          ? {
              ...doc,
              [fieldName]: value,
              ...(fieldName === 'service_agreement_id' && {
                health_care_partner: '',
              }),
            } // Update the specific field
          : // Set 'health_care_partner' to an empty string if 'service_agreement_id' is being updated
            doc,
      ),
    );
  };

  const handleDateChange = (
    Date: any,
    fieldName: string,
    documentId: string,
  ) => {
    setUploadedDocuments((prevDocuments) =>
      prevDocuments.map((doc) =>
        doc.document_id === documentId
          ? { ...doc, [fieldName]: Date } // Update the specific field
          : doc,
      ),
    );
  };

  const handleInputChange = async (value: string, document_id: string) => {
    setHealthcarePartners((prev) => [...prev, value]);

    setUploadedDocuments((prevDocuments) =>
      prevDocuments.map(
        (doc) =>
          doc.document_id === document_id
            ? {
                ...doc,
                ['health_care_partner']: value,
              } // Update the specific field
            : doc, // Leave other documents unchanged
      ),
    );
  };

  //Plan Documents Onboard handlechange functions
  const handleChangePlanDocs = (
    event: any,
    fieldName: string,
    documentId: string,
  ) => {
    const value = event.target.value as string;
    setUploadedPlanDocuments((prevDocuments) =>
      prevDocuments.map((doc) =>
        doc.document_id === documentId
          ? {
              ...doc,
              [fieldName]: value,
            } // Update the specific field
          : doc,
      ),
    );
  };

  const handlePlanDocsDateChange = (
    Date: any,
    fieldName: string,
    documentId: string,
  ) => {
    setUploadedPlanDocuments((prevDocuments) =>
      prevDocuments.map(
        (doc) =>
          doc.document_id === documentId
            ? { ...doc, [fieldName]: Date } // Update the specific field
            : doc, // Leave other documents unchanged
      ),
    );
  };

  const handlePlanChange = (
    value: string,
    fieldName: string,
    documentId: string,
  ) => {
    setPlanTypes((prev) => [...prev, value]);
    setUploadedPlanDocuments((prevDocuments) =>
      prevDocuments.map(
        (doc) =>
          doc.document_id === documentId
            ? { ...doc, [fieldName]: value } // Update the specific field
            : doc, // Leave other documents unchanged
      ),
    );
  };

  // Merge Documents Functions
  const documentMergerAction = async (id: string, isPlanDoc: boolean) => {
    if (isPlanDoc) {
      contractAiqStore.setPlanId(id);
      contractAiqStore.setContractId('');
    } else {
      contractAiqStore.setPlanId('');
      contractAiqStore.setContractId(id);
    }
    navigate('/merge-documents');
  };

  const handleContractRowClick = async (row: any) => {
    contractAiqStore.setContractId(row.contract_id);
    navigate(CONTRACT_AIQ_INTERNAL, {
      state: {
        contract: row.type,
        healthcarePartner: row.name,
      },
    });
  };

  const handlePlanRowClick = async (row: any) => {
    const tabIndex = row.type === 'SPD' ? 1 : 0;
    navigate(PLAN_DOCUMENTS_INTERNAL, { state: { tabIndex } });
  };

  const masterDocumentUploadAction = async (
    id: string,
    docId: string,
    isPlanDoc: boolean,
    data: any,
  ) => {
    contractAiqStore.setData(data);
    if (isPlanDoc) {
      contractAiqStore.setPlanId(id);
      contractAiqStore.setDocumentSelected(docId);
    } else {
      contractAiqStore.setContractId(id);
      contractAiqStore.setDocumentSelected(docId);
    }
    setUploadMasterDocPopUp(true);
  };

  const handleUploadPopupClose = async () => {
    setUploadMasterDocPopUp(false);
    contractAiqStore.setContractId('');
    contractAiqStore.setDocumentSelected('');
    contractAiqStore.setPlanId('');
  };

  const handleSavePlanDocReports = async (row: any) => {
    handleOpenSnackBar(
      'Update plan document reports is in progress',
      'info',
      2000,
    );

    try {
      await addPlanDocsReports([row]);
      handleOpenSnackBar(
        'Plan Document Reports updated successfully',
        'success',
        2000,
      );
    } catch (error: any) {
      handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
    }
  };

  const handleSaveContractReports = async (row: any) => {
    handleOpenSnackBar('Update contract reports is in progress', 'info', 2000);

    try {
      await addReports([row]);
      handleOpenSnackBar(
        'Contract Reports updated successfully',
        'success',
        2000,
      );
    } catch (error: any) {
      handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
    }
  };

  const handleRowMenuItemClick = async (row: any, menuItem: string) => {
    const { plan_id } = row;
    switch (menuItem) {
      case 'Delete':
        await axios.post(
          properties.aiqBaseUrl + properties.contractBaseUrl + '/delete-plan',
          {
            plan_id,
          },
        );
        await getPlanDocs();
        break;
      default:
        break;
    }
  };

  const handleSubRowMenuItemClick = async (
    row: any,
    subrow: any,
    menuItem: string,
  ) => {
    const { id } = subrow;
    switch (menuItem) {
      case 'Delete Document':
        await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            '/delete-plan-doc',
          {
            document_id: id,
          },
        );
        await getPlanDocs();
        return;
      default:
        return;
    }
  };

  //APIs
  //Document Management Apis
  const uploadDocConversion = async (
    document: any,
    isPlanDoc: boolean,
    isFinal?: boolean,
  ) => {
    await axios.post(
      properties.aiqBaseUrl +
        properties.contractBaseUrl +
        properties.uploadDocConversion,
      {
        document,
        employer:
          employerGroupStore.employerGroupResponseData.employer_group_name[0],
        isPlanDocument: isPlanDoc,
        isFinal: isFinal,
      },
    );
  };

  const updateDocConversion = async (id: string, isPlanDoc: boolean) => {
    await axios.post(
      properties.aiqBaseUrl +
        properties.contractBaseUrl +
        properties.updateDocConversion,
      {
        id: id,
        isPlanDoc: isPlanDoc,
      },
    );
  };

  const documentDownloadAction = async (id: string, isPlanDoc: any) => {
    handleOpenSnackBar(
      'Documents are getting downloaded. Please wait',
      'success',
      6000,
    );
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.downloadFiles,
        {
          id: id,
          isPlanDoc: isPlanDoc,
        },
      )
      .then(async (res) => {
        const zip = new JSZip();
        res.data.data.forEach((file: any) => {
          // Convert base64 to Blob
          const binary = atob(file.base64);
          const arrayBuffer = new Uint8Array(binary.length);
          for (let i = 0; i < binary.length; i++) {
            arrayBuffer[i] = binary.charCodeAt(i);
          }
          const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

          // Add to zip folder
          zip.file(file.document_name, blob);
        });

        // Generate and download the zip
        const zipBlob = await zip.generateAsync({ type: 'blob' });
        saveAs(zipBlob, 'files.zip');
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const uploadMasterDocument = async () => {
    const isPlanDoc = contractAiqStore.planId !== '';
    const id = isPlanDoc
      ? contractAiqStore.planId
      : contractAiqStore.contractId;
    const formData = new FormData();
    // Append files to the form data
    uploadedMasterDoc.forEach((file: any) => {
      formData.append(`files`, file);
    });
    // Append other form data
    formData.append(
      'employer',
      employerGroupStore.employerGroupResponseData.employer_group_name[0],
    );
    formData.append('id', id);
    formData.append('document_id', contractAiqStore.documentSelected);
    formData.append('isPlanDoc', String(isPlanDoc));
    setLoading(true);
    setUploadMasterDocPopUp(false);
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.uploadMasterDoc,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then(async (res: any) => {
        if (res.status === 200) {
          isPlanDoc ? await getPlanDocs() : await getContracts();
          setLoading(false);
          const data = contractAiqStore.data;
          handleOpenSnackBar('Document Merged Successfully', 'success', 6000);
          await Promise.all([
            ...res.data.data.map(async (item: any) => {
              if (!isPlanDoc) {
                await extractAndSaveMetadataForContract(
                  employerGroupStore.employerGroupResponseData.eg_nid[0],
                  id,
                  data.service_agreement_name,
                  item?.document_url,
                );
                if (data.reports?.includes('Provision Matrix')) {
                  await extractAndSaveProvisionMatrix(
                    item?.document_url,
                    id,
                    employerGroupStore.employerGroupResponseData.eg_nid[0],
                    data.service_agreement_name,
                  );
                }
                await Promise.all(
                  data.reports?.map(async (report: string) => {
                    const {
                      compareAgreementId,
                      compareUrl,
                    } = extractCompareAgreementDetails(data, report);
                    await extractReport(
                      id,
                      item?.document_url,
                      report,
                      egNid,
                      compareAgreementId,
                      compareUrl,
                      '',
                      false,
                      employer,
                    );
                  }),
                );
              }
              await uploadDocConversion(item, isPlanDoc, true);
            }),
          ]);
          await updateDocConversion(id, isPlanDoc);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  //Contract onboard APIs

  const getComplianceAssuranceGroupById = async (group_id: string) => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getGroupById,
        {
          group_id: group_id,
        },
      )
      .then((res: any) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          setGroupFieldsData({
            Group: data?.employer_name,
            'Claims Administrator': data?.tpa,
            PBM: data?.pbm,
            'Stop Loss Carrier': data?.stop_loss_carrier,
            // 'Network Carrier': data?.network,
            'Advisor/Broker': data?.advisor_or_broker,
          });
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const getServiceAgreements = async () => {
    await axios
      .get(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getServiceAgreements,
      )
      .then((res: any) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          setServiceAgreements(data);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const uploadDocuments = async () => {
    setContractLoading(true);

    const formData = new FormData();
    // Append files to the form data
    selectedFiles.forEach((file: any) => {
      formData.append(`files`, file);
    });
    // Append other form data
    formData.append('employer', employer);
    formData.append('eg_nid', egNid);

    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.uploadContracts,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then(async (res: any) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          setUploadedDocuments(
            data?.map((item: any) => ({
              document_id: item?.document_id,
              document_name: item?.document_name,
              document_url: item?.document_url,
              document_type: item?.document_type,
              document_effective_date: item?.effective_date,
              service_agreement_id: item?.service_agreement_id,
              health_care_partner: item?.health_care_partner,
            })),
          );
          setContractLoading(false);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
        setContractStep(0);
        setContractLoading(false);
      });
  };

  const createContracts = async () => {
    setContractLoading(true);
    const egNid = employerGroupStore.employerGroupResponseData.eg_nid[0];
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.addContract,
        {
          eg_nid: egNid,
          documents: uploadedDocuments,
        },
      )
      .then(async (res: any) => {
        if (res.status === 200) {
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const getContracts = async () => {
    try {
      setContractLoading(true);
      const egNid = employerGroupStore.employerGroupResponseData.eg_nid[0];
      const response = await axios.post(
        `${properties.aiqBaseUrl}${properties.contractBaseUrl}${properties.getContracts}`,
        { eg_nid: egNid },
      );
      if (response.status !== 200) {
        throw new Error('Failed to fetch contracts');
      }
      const data = response.data?.data;
      // Generate contracts table data
      const contractsTableData = data?.map((item: any) =>
        formatContractData(item, uploadedDocuments),
      );
      setContractsTableData(contractsTableData);

      // Generate reports table data
      const reportsTableData = formatReportsData(data);
      setReportsTableData(reportsTableData);

      // Generate merge contracts table data
      let contractWithAmendmentsCount = 0;
      const mergeContractsTableData = data?.map((item: any) => {
        if (
          item.type?.toLowerCase().includes('amendment') &&
          item.merge_status === 'Not Merged'
        ) {
          contractWithAmendmentsCount++;
        }
        return formatMergeContractData(
          item,
          documentMergerAction,
          documentDownloadAction,
          masterDocumentUploadAction,
        );
      });
      setContractsWithAmendmentsCount(contractWithAmendmentsCount);
      setMergeContractsTableData(mergeContractsTableData);
    } catch (error) {
      handleOpenSnackBar('Failed to fetch contracts', 'error', 6000);
    } finally {
      setContractLoading(false);
    }
  };

  const addReports = async (data: any) => {
    const reportList = formatContractReports(data, reportsTableData);

    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.addReports,
        {
          eg_nid: employerGroupStore.employerGroupResponseData.eg_nid[0],
          reportList: reportList,
        },
      )
      .then(async (res: any) => {
        if (res?.status === 200) {
          const data = res?.data?.data;
          //report extraction for all base contracts
          (async () => {
            for (const contract of data || []) {
              const {
                contract_id,
                service_agreement_name,
                features,
              } = contract;

              if (contract?.type === 'Base Document') {
                const baseDocument = contract?.documents?.find(
                  (doc: any) =>
                    doc?.document_type === 'Base Document' ||
                    doc?.document_type === 'Master Document',
                );

                const documentUrl =
                  baseDocument?.markdown_url || baseDocument?.document_url;
                if (features?.length > 0) {
                  await extractAndSaveMetadataForContract(
                    egNid,
                    contract_id,
                    service_agreement_name,
                    documentUrl,
                    '',
                    getUrlsForServiceAgreement(
                      service_agreement_name,
                      features,
                    ),
                  );
                }
                if (contract?.features?.includes('Fees')) {
                  await extractAndSaveFees(
                    documentUrl,
                    contract_id,
                    egNid,
                    service_agreement_name,
                  );
                }

                if (contract.features?.includes('Summary of Findings')) {
                  await extractAndSaveSummary(documentUrl, contract_id, egNid);
                }

                const allowedFeatures = [
                  'Key Terms Compilation',
                  'Red Flags Check',
                  'Missing Checks',
                  'Fees',
                ];

                // Find intersection between allowed features and the contract's features
                const activeFeatures = (
                  contract?.features || []
                ).filter((f: string) => allowedFeatures.includes(f));

                if (activeFeatures.length > 0) {
                  for (const feature of activeFeatures) {
                    await extractAndSaveProvisionMatrixData(
                      documentUrl,
                      contract_id,
                      egNid,
                      employer,
                      service_agreement_name,
                      getCategoryByFeature(feature),
                    );
                  }
                }

                contract?.reports?.length > 0 &&
                  (await createNamespace(baseDocument?._id, documentUrl));
                await new Promise((resolve) => setTimeout(resolve, 5000));

                if (Array.isArray(contract?.reports)) {
                  for (const report of contract.reports) {
                    const {
                      compareAgreementId,
                      compareUrl,
                    } = extractCompareAgreementDetails(data, report);

                    await extractReport(
                      contract_id,
                      documentUrl,
                      report,
                      egNid,
                      compareAgreementId,
                      compareUrl,
                      '',
                      false,
                      employer,
                    );
                  }
                }
              }
            }
          })();
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const contractOnboardAPICalls = async () => {
    switch (contractStep) {
      case 0:
        await getServiceAgreements();
        setLoading(false);
        break;
      case 1:
        await uploadDocuments();
        break;
      case 2:
        await createContracts();
        await getContracts();
        break;
      case 4:
        await addReports(reportsTableData);
        setIsPlanDocsPopupOpen(true);
        break;
      default:
        break;
    }
  };

  //Plan Documents onboard APIs
  const uploadPlanDocuments = async () => {
    setPlansLoading(true);

    const formData = new FormData();
    // Append files to the form data
    selectedPlanDocs.forEach((file: any) => {
      formData.append(`files`, file);
    });
    // Append other form data
    formData.append('employer', employer);

    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.uploadPlanDocs,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then(async (res: any) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          const updatedPlanDocuments = data?.map((item: any) => ({
            document_id: item?._id,
            document_name: item?.document_name,
            document_url: item?.document_url,
            markdown_url: item?.markdown_url,
          }));
          setUploadedPlanDocuments(updatedPlanDocuments);
          await Promise.all([
            ...updatedPlanDocuments.map(async (doc: any) =>
              extractDataFromPlanDocs(doc?.markdown_url, doc?.document_id),
            ),
          ]);
          setPlansLoading(false);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
        setPlanDocsStep(0);
        setPlansLoading(false);
      });
  };

  // const extractDataFromPlanDocs = async (
  //   fileUrl: string,
  //   documentId: string,
  // ) => {
  //   const planTypeQuestion =
  //     "What is the plan type of the provided document? Please respond with the specific plan type in the following JSON format: { 'plan_type': answer  }";
  //   const documentTypeQuestion =
  //     "Is the document provided a Plan Document or Summary Plan Description?  Please respond with one of the following options: 'SPD' (if the document is a Plan Document or Summary Plan Description) or 'SOB' (if the document is a Summary of Benefits). Output the result in the following JSON format: {'doc_type': SPD/SOB}.";
  //   const baseDocumentQuestion =
  //     "Is the document a base document or an amendment? Please respond with one of the following options: true (if the document is a base document) or false (if the document is an amendment). Output the result in the following JSON format: {'is_base_document': true/false}.";
  //   const planStartDateQuestion =
  //     "What is the start date of the plan mentioned in the provided document? Please provide the answer in the format 'MM-DD-YYYY'. If the effective date is not present or unclear, return null. Provide the output in JSON format as follows: {'plan_start_date': 'MM-DD-YYYY' or null}.";
  //   const planEndDateQuestion =
  //     "What is the end date of the plan mentioned in the provided document? Please provide the answer in the format 'MM-DD-YYYY'. If the effective date is not present or unclear, return null. Provide the output in JSON format as follows: {'plan_end_date': 'MM-DD-YYYY' or null}.";

  //   try {
  //     // Run all API calls independently, handling each result (success or failure)
  //     const [
  //       planTypeResult,
  //       documentTypeResult,
  //       baseDocumentResult,
  //       planStartDateResult,
  //       planEndDateResult,
  //     ] = await Promise.allSettled([
  //       extractCustomMetadataFromContract(fileUrl, planTypeQuestion),
  //       extractCustomMetadataFromContract(fileUrl, documentTypeQuestion),
  //       extractCustomMetadataFromContract(fileUrl, baseDocumentQuestion),
  //       extractCustomMetadataFromContract(fileUrl, planStartDateQuestion),
  //       extractCustomMetadataFromContract(fileUrl, planEndDateQuestion),
  //     ]);

  //     // Extract values if fulfilled, or set to default if rejected
  //     const planType =
  //       planTypeResult.status === 'fulfilled'
  //         ? planTypeResult?.value?.plan_type
  //         : null;

  //     const docType =
  //       documentTypeResult.status === 'fulfilled'
  //         ? documentTypeResult.value?.doc_type
  //         : null;

  //     const isBaseDocument =
  //       baseDocumentResult.status === 'fulfilled'
  //         ? baseDocumentResult.value?.is_base_document
  //         : null;

  //     const planStartDate =
  //       planStartDateResult.status === 'fulfilled'
  //         ? planStartDateResult.value?.plan_start_date
  //         : null;

  //     const planEndDate =
  //       planEndDateResult.status === 'fulfilled'
  //         ? planEndDateResult.value?.plan_end_date
  //         : null;

  //     setUploadedPlanDocuments((prevDocuments) =>
  //       prevDocuments.map(
  //         // eslint-disable-next-line max-nested-callbacks
  //         (doc) =>
  //           doc.document_id === documentId
  //             ? {
  //                 ...doc,
  //                 ['plan_type']: planType,
  //                 ['document_type']: docType,
  //                 ['document_sub_type']: isBaseDocument
  //                   ? 'Base Document'
  //                   : 'Amendment',
  //                 ['plan_start_date']: planStartDate,
  //                 ['plan_end_date']: planEndDate,
  //               }
  //             : doc,
  //       ),
  //     );
  //     setContractLoading(false);
  //   } catch (error: any) {
  //     handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
  //   }
  // };

  const extractDataFromPlanDocs = async (
    fileUrl: string,
    documentId: string,
  ) => {
    const prompt = `You are a classification model designed to analyze employee benefit documents and extract structured metadata for compliance and vendor tracking.\n\nYou will be provided with:\n1. Benefits-related document.\n2. A CSV of standardized benefit types.\n3. A CSV of standardized vendor types and responsibilities.\n4. An optional list of known vendor names (may be empty).\n\n---\n\nYour task is to return the following:\n\n1. Benefit types described (from the CSV of standardized benefit types).\n2. Document type (from: Summary Plan Description, Policy Document, Benefits Summary, Amendment Document).\n3. Whether the document is a base document or an amendment.\n4. Effective date of the document.\n5. Document Summary.\n6. Plan sponsor name.\n7. Plan names (if any).\n8. List of vendors involved:\n   - Match vendor names to the provided list if available; otherwise extract from the document.\n   - Match vendor types using the vendor type CSV.\n   - If no vendor type matches or is close, define a new vendor type.\n\n---\n\n### Guidelines:\n\n**Benefit Types**\n- Use exact matches from the benefit type CSV.\n- Include all applicable types.\n- Only create a new type if no close match exists.\n\n**Plan Names**\n- Identify coverage tier names (e.g., Basic PPO, Buy-Up, HDHP with HSA).\n- Include all found; return an empty list if none.\n\n**Document Summary**\n-Extract document_summary in a brief, clear paragraph summarizing the uploaded document, focusing on its purpose, key points, and main conclusions.\n\n**Vendors**\n- Use vendor names from the list if matched; otherwise extract.\n- Match vendor types to the vendor type CSV.\n- Only create a new type if no existing type fits or comes close.\n\n\nSample Output:{sample_output} \n\n\nAn optional list of known vendor names (may be empty): Vendor Names List\nA CSV of standardized vendor types and responsibilities: {Vendor_Types}\nA CSV of standardized benefit types: {Standard_Benefit_Types}\nBenefits-related document: {document}`;
    const sampleOutput = convertToJSONString({
      benefit_classification: {
        benefit_types: ['Medical', 'Prescription Drug (Rx) Benefit'],
        document_type: 'Summary Plan Description',
        document_nature: 'base',
        document_summary: '<summary of document>',
        match_reason: 'SPD describing medical and pharmacy benefits.',
      },
      document_metadata: {
        plan_names: ['HDHP with HSA', 'Buy-Up PPO'],
        sponsor_name: 'Acme Corporation',
        effective_date: '2024-01-01',
      },
      vendors: [
        {
          vendor_name: 'UnitedHealthcare',
          vendor_type: 'Administrative Services Only (ASO) Provider',
          match_reason:
            'Handles claims and network access under self-funded plan.',
        },
        {
          vendor_name: 'OptumRx',
          vendor_type: 'Pharmacy Benefit Manager (PBM)',
          match_reason: 'Manages pharmacy benefits, formulary, and claims.',
        },
      ],
    });

    try {
      const result = await promptChain(
        prompt,
        { sample_output: sampleOutput },
        {
          Standard_Benefit_Types:
            'https://storageblobprod.blob.core.windows.net/contract/static-uploads/Onboarding/Benefit Types.csv',
          Vendor_Types:
            'https://storageblobprod.blob.core.windows.net/contract/static-uploads/Onboarding/Vendor Types.csv',
          document: fileUrl,
        },
        'gpt-5-mini',
        'https://storageblobprod.blob.core.windows.net/contract/static-uploads/Onboarding/PlanDoc_JSON_Schema.json',
      );

      const { benefit_classification, document_metadata, vendors } = result;
      const {
        benefit_types,
        document_type,
        document_nature,
        match_reason,
        document_summary,
      } = benefit_classification;
      const { plan_names, sponsor_name, effective_date } = document_metadata;
      const docTypeMap: any = {
        'Summary Plan Description': 'SPD',
        'Summary Of Benefits': 'SOB',
      };
      const planNameList = [...planNames, ...plan_names];
      setPlanNames(planNameList);
      setUploadedPlanDocuments((prevDocuments) =>
        prevDocuments.map((doc) =>
          doc.document_id === documentId
            ? {
                ...doc,
                ['benefit_types']: benefit_types,
                ['document_type']: docTypeMap[document_type],
                ['document_sub_type']: document_nature,
                ['plan_names']: plan_names,
                ['effective_date']: effective_date,
                ['benefits_match_reason']: match_reason,
                ['sponsor_name']: sponsor_name,
                ['vendors']: vendors,
                ['document_summary']: document_summary,
              }
            : doc,
        ),
      );
    } catch (error: any) {
      handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
    }
  };

  const addPlanDocs = async () => {
    setPlansLoading(true);
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.addPlanDocs,
        {
          eg_nid: egNid,
          documents: uploadedPlanDocuments,
        },
      )
      .then(async (res: any) => {
        if (res.status === 200) {
          const planIdList: any[] = [];
          const data = res.data.data;

          const spdPlans =
            data?.find((item: any) => item.doc_type === 'SPD')?.plans || [];

          spdPlans?.map(async (plan: any) => {
            Promise.all(
              plan?.documents?.map(async (item: any) => {
                planIdList.push(plan._id);
                await uploadDocConversion(
                  { ...item, spd_plans_id: plan?._id },
                  true,
                  false,
                );
              }),
            )

              .then(() => {
                Promise.all(
                  planIdList.map(async (id: any) => {
                    await updateDocConversion(id, true);
                  }),
                );
              })

              .catch((err) => {
                throw err;
              });
          });
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const getPlanDocs = async () => {
    setPlansLoading(true);
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getPlanDocs,
        {
          eg_nid: egNid,
        },
      )
      .then(async (res: any) => {
        if (res.status === 200) {
          const data = res?.data?.data || [];
          const formattedData = data?.map((item: any) => ({
            id: item?._id,
            benefitTypes:
              item?.benefit_types && item.benefit_types.length > 0
                ? item.benefit_types
                : [],
            docType: item?.document_type,
            planNames: item?.plan_names ?? [],
            vendors: item?.vendors ?? [],
            subRows:
              item?.documents?.map((doc: any) => ({
                docName: doc?.document_name || '',
                docType: doc?.document_type || '',
                effectiveDate: doc?.document_effective_date || '',
              })) ?? [],
          }));
          setPlanDocsTableData(formattedData);

          const planDocMergeTableData = formatMergePlanDocsData(
            data,
            documentMergerAction,
            documentDownloadAction,
            masterDocumentUploadAction,
          );
          setPlanDocWithAmendmentsCount(
            planDocMergeTableData.contractWithAmendmentsCount,
          );
          setMergePlanDocTableData(planDocMergeTableData.data);

          const reports = [
            'ERISA Regulatory Compliance Check',
            'Overview',
            'Exclusion Analysis',
          ];

          const response = await axios.post(
            `${properties.aiqBaseUrl}${properties.contractBaseUrl}${properties.getContracts}`,
            { eg_nid: egNid },
          );
          if (response.status !== 200) {
            throw new Error('Failed to fetch contracts');
          }
          const contracts = response.data?.data;
          const asaContract = contracts?.find(
            (cont: any) =>
              (cont?.service_agreement_name ===
                'Third-Party Administrator (TPA)' ||
                cont?.service_agreement_name ===
                  'Administrative Services Only (ASO) Provider') &&
              cont.merge_status === 'Merged',
          );
          if (asaContract) {
            reports.push('Comparison with Administrative Service Agreement');
          }

          const stoplossContract = contracts?.find(
            (cont: any) =>
              cont?.service_agreement_name === 'Stop-Loss Insurance Provider' &&
              cont.merge_status === 'Merged',
          );
          if (stoplossContract) {
            reports.push('Gap Analysis');
          }
          const pbmContract = contracts?.find(
            (cont: any) =>
              cont?.service_agreement_name ===
                'Pharmacy Benefit Manager (PBM)' &&
              cont.merge_status === 'Merged',
          );
          if (pbmContract) {
            reports.push('Comparison with PBM Service Agreement');
          }

          const planDocs = data?.filter(
            (item: any) => item?.document_type === 'SPD',
          );

          setPlanDocsReportsTableData(
            planDocs?.map((item: any) => ({
              name: arrayToString(item?.benefit_types),
              type: arrayToString(item?.plan_names),
              selectedReports: item?.reports ?? [],
              reports: reports,
              asaContract,
              stoplossContract,
              pbmContract,
              planDoc: item,
              showSave: item?.merge_status === 'Merged',
            })),
          );

          setPlansLoading(false);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const addPlanDocsReports = async (data: any[]) => {
    const reportList = formatPlanDocsReports(data);

    const egNid = employerGroupStore.employerGroupResponseData.eg_nid[0];
    const employer =
      employerGroupStore.employerGroupResponseData.employer_group_name[0];
    await axios
      .post(
        properties.aiqBaseUrl + properties.contractBaseUrl + '/add-spd-reports',
        {
          eg_nid: egNid,
          reportList: reportList,
        },
      )
      .then((res: any) => {
        if (res.status === 200) {
          const data = res.data.data;

          const planDocs =
            data?.filter((item: any) => item?.document_type === 'SPD') || [];
          planDocs?.map((plan: any) => {
            if (plan?.merge_status === 'Merged') {
              const planDoc = plan?.documents?.find(
                (item: any) =>
                  item?.document_type === 'Base Document' ||
                  item?.document_type === 'Master Document',
              );

              plan.reports?.map(async (report: string) => {
                let compareUrl: string = '';
                let compareAgreementId: string = '';
                switch (report) {
                  case 'Comparison with Administrative Service Agreement':
                  case 'Gap Analysis':
                  case 'Comparison with PBM Service Agreement':
                    const planReportsObj =
                      reportList?.find(
                        (item: any) => item?.plan_id === plan._id,
                      )?.reports || [];
                    const reportObj = planReportsObj?.find(
                      (rep: any) => rep.report === report,
                    );
                    compareUrl = reportObj?.compareUrl;
                    compareAgreementId = reportObj?.compare_agreement_id;
                    break;
                }
                await extractPlanDocsReport(
                  plan?._id,
                  planDoc?.document_url,
                  report,
                  egNid,
                  compareAgreementId,
                  compareUrl,
                  employer,
                  planDoc?.markdown_url,
                );
              });
            }
          });
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const getPlanTypes = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getPlanDocs,
        {
          eg_nid: employerGroupStore.employerGroupResponseData.eg_nid[0],
        },
      )
      .then((res: any) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          const plans: string[] = [];
          data?.map((item: any) => {
            item?.plans?.map((plan: any) => {
              plans.push(plan.plan_type);
            });
          });
          setPlanTypes(plans);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const planDocsOnboardAPICalls = async () => {
    switch (planDocsStep) {
      case 1:
        await getPlanTypes();
        await uploadPlanDocuments();
        break;
      case 2:
        await addPlanDocs();
        await getPlanDocs();
        break;
      case 4:
        await addPlanDocsReports(planDocsReportsTableData);
        if (
          contractsWithAmendmentsCount > 0 ||
          planDocWithAmendmentsCount > 0
        ) {
          setIsMergeDocsPopupOpen(true);
        } else {
          navigate(ONBOARDINGSTATUS);
        }
        break;
      default:
        break;
    }
  };

  //UseEffects
  // useEffect(() => {
  //   groupId !== '' && getComplianceAssuranceGroupById(groupId);
  // }, [groupId]);

  //Contracts UseEffects
  useEffect(() => {
    contractOnboardAPICalls();
  }, [contractStep]);

  // useEffect(() => {
  //   const serviceAgreementMap: Record<string, string> = {
  //     'Claims Administrator': 'Claims Administrator',
  //     PBM: 'Pharmacy Benefit Management',
  //     'Stop Loss Carrier': 'Stop Loss Carrier',
  //     // 'Network Carrier': 'Network Carrier',
  //     'Advisor/Broker': 'Advisor / Broker',
  //   };

  //   const updatedFields = Object.keys(serviceAgreementMap).reduce(
  //     (acc, key) => {
  //       const serviceAgreement = serviceAgreements?.find(
  //         // eslint-disable-next-line max-nested-callbacks
  //         (item: any) =>
  //           item.service_agreement_name === serviceAgreementMap[key],
  //       );

  //       const healthCarePartner = healthcarePartners?.find(
  //         // eslint-disable-next-line max-nested-callbacks
  //         (item: any) => item?.service_agreement_id === serviceAgreement?._id,
  //       )?.health_care_partner;

  //       return { ...acc, [key]: healthCarePartner || '-' };
  //     },
  //     {},
  //   );

  //   setGroupFieldsData((prevState) => ({
  //     ...prevState,
  //     ...updatedFields,
  //   }));
  // }, [healthcarePartners]);

  useEffect(() => {
    switch (contractStep) {
      case 0:
        setIsContractsButtonDisabled(selectedFiles?.length === 0);
        break;
      case 1:
        setIsContractsButtonDisabled(
          !checkAllFieldsFilled(uploadedDocuments, ['document_effective_date']),
        );
        break;
      default:
        break;
    }
  }, [selectedFiles, uploadedDocuments, contractStep]);

  //Plan Documents UseEffects
  useEffect(() => {
    activeStep === 1 && planDocsOnboardAPICalls();
  }, [planDocsStep]);

  useEffect(() => {
    if (egNid) {
      getContracts();
      getPlanDocs();
    }
  }, [egNid]);

  useEffect(() => {
    switch (planDocsStep) {
      case 0:
        setIsPlanDocsButtonDisabled(selectedPlanDocs?.length === 0);
        break;
      case 1:
        setIsPlanDocsButtonDisabled(
          !checkAllFieldsFilled(uploadedPlanDocuments, [
            'benefits_match_reason',
            'sponsor_name',
            'vendors',
          ]),
        );
        break;
      default:
        break;
    }
  }, [selectedPlanDocs, uploadedPlanDocuments, planDocsStep]);

  //Components
  //Tabs Content components
  const UploadDocumentsTab = () => {
    return (
      <Grid>
        <Grid className={classes.onboardingCards}>
          {/* <Grid className={classes.groupDetails}>
            {Object.entries(groupFieldsData).map(([key, value]) => (
              <Grid key={key} className={classes.detail}>
                <TextWithIcon
                  label={
                    <Typography
                      fontSize="12px"
                      fontType="regular"
                      lineHeight="19.2px"
                      textColor={patientAccessTheme.palette.text.mediumemphasis}
                    >
                      {key}
                    </Typography>
                  }
                  endIcon={<></>}
                />
                <TextWithIcon
                  startIcon={
                    key === 'Group' && (
                      <Avatar
                        avatarText={
                          <Typography
                            fontSize="14px"
                            lineHeight="16.7px"
                            fontType="semiBold"
                            textColor={patientAccessTheme.palette.status.white}
                          >
                            {value?.charAt(0)?.toUpperCase()}
                          </Typography>
                        }
                        height="28px"
                        width="28px"
                        alt={value}
                        backgroundColor={
                          patientAccessTheme.palette.primary[300]
                        }
                      />
                    )
                  }
                  label={
                    <Typography
                      fontSize="14px"
                      fontType="medium"
                      lineHeight="24px"
                      textColor={patientAccessTheme.palette.text.highemphasis}
                      className={key === 'Group' ? '' : classes.ellipses}
                    >
                      {value || '-'}
                    </Typography>
                  }
                  startIconRightMargin="11px"
                />
              </Grid>
            ))}
          </Grid> */}
          <Grid className={classes.stepsGrid}>
            <TabStepper
              steps={messages.ONBOARDING_TABS}
              stepWidth="100%"
              activeStep={activeStep}
              handleStepOnClick={(index) => {
                setActiveStep(index);
              }}
              completedSteps={completedSteps}
            />
            {getStepContent()}
          </Grid>
        </Grid>
        {activeStep === 0 &&
          (contractStep === 0 || contractStep === 1) &&
          contractsTableData?.length > 0 && (
            <CardComponent
              title={''}
              mainGridStyles={{ marginTop: '32px' }}
              body={<Contracts />}
            />
          )}
        {activeStep === 1 &&
          (planDocsStep === 0 || planDocsStep === 1) &&
          planDocsTableData?.length > 0 && (
            <CardComponent
              title={''}
              mainGridStyles={{ marginTop: '32px' }}
              body={
                <>
                  <Typography
                    fontSize="14px"
                    fontType="semiBold"
                    lineHeight="24px"
                    textColor={patientAccessTheme.palette.text.highemphasis}
                  >
                    {messages.PLAN_DOCS.TITLE}
                  </Typography>
                  <Typography
                    fontSize="12px"
                    fontType="regular"
                    lineHeight="24px"
                    textColor={patientAccessTheme.palette.text.mediumemphasis}
                    margin="0px 0px 20px 0px"
                  >
                    {messages.PLAN_DOCS.SUB_TITLE}
                  </Typography>
                  <Grid className={classes.contractsTable}>
                    <CustomTable
                      columns={planDocsColumns}
                      subColumns={[
                        {
                          header: 'Doc Name',
                          accessor: 'docName',
                        },
                        {
                          header: 'Doc Type',
                          accessor: 'docType',
                        },
                        {
                          header: 'Effective Date',
                          accessor: 'effectiveDate',
                        },
                      ]}
                      rowsData={planDocsTableData}
                    />
                  </Grid>
                </>
              }
            />
          )}
      </Grid>
    );
  };

  const MergeDocumentsTab = () => {
    return (
      <>
        <CardComponent
          title={messages.CONTRACT}
          body={
            mergeContractsTableData.length > 0 ? (
              <ContractsTable
                rowsData={mergeContractsTableData}
                columns={contractColumns}
                showActionButtons={true}
                handleRowClick={handleContractRowClick}
              />
            ) : (
              <NoDataTable
                height={'100%'}
                width={'100%'}
                content={'No Contracts Available'}
              />
            )
          }
        />
        <CardComponent
          title={messages.PLAN_DOCUMENTS}
          mainGridStyles={{ marginTop: '20px' }}
          body={
            mergePlanDocTableData.length > 0 ? (
              <ContractsTable
                rowsData={mergePlanDocTableData}
                columns={planDocColumns}
                showActionButtons={true}
                handleRowClick={handlePlanRowClick}
              />
            ) : (
              <NoDataTable
                height={'100%'}
                width={'100%'}
                content={'No Plan Documents Available'}
              />
            )
          }
        />
      </>
    );
  };

  const ReportsTab = () => {
    return (
      <>
        {reportsTableData?.length > 0 && (
          <CardComponent
            title={'Contract Documents'}
            titleSubTitleMargin="12px"
            body={
              <ReportsSelectionTable
                rowsData={reportsTableData}
                setRowsData={setReportsTableData}
                columns={[
                  'Healthcare Partner',
                  'Service Agreement Type',
                  'Analysis/Reports',
                  '',
                ]}
                showSaveButton
                handleSaveButton={handleSaveContractReports}
              />
            }
            mainGridStyles={{ marginBottom: '20px' }}
          />
        )}
        {planDocsReportsTableData?.length > 0 && (
          <CardComponent
            title={'Plan Documents'}
            titleSubTitleMargin="12px"
            body={
              <ReportsSelectionTable
                rowsData={planDocsReportsTableData}
                setRowsData={setPlanDocsReportsTableData}
                columns={['Benefit Types', 'Plan Names', 'Reports', '']}
                showSaveButton
                handleSaveButton={handleSavePlanDocReports}
              />
            }
          />
        )}
      </>
    );
  };

  const UploadDocumentModal = () => {
    return (
      <Modal
        style={{ zIndex: 500 }}
        open={uploadMasterDocPopUp}
        onClose={handleUploadPopupClose}
      >
        <Grid container className={classes.uploadModal} style={{ gap: '20px' }}>
          <Grid
            container
            sx={{
              justifyContent: 'space-between',
            }}
          >
            <Grid>
              <Typography
                fontSize="18px"
                lineHeight="26px"
                fontType="medium"
                textColor={patientAccessTheme.palette.text.highemphasis}
                margin="0px 0px 4px 0px"
              >
                {messages.UPLOAD_MASTER_DOCUMENT}
              </Typography>
            </Grid>
            <Grid style={{ height: '14px', width: '14px' }}>
              <Close
                height={'14px'}
                width={'14px'}
                fill={patientAccessTheme.palette.status.icon}
                onClick={handleUploadPopupClose}
                cursor={'pointer'}
              />
            </Grid>
          </Grid>
          {UploadFiles(uploadedMasterDoc, setUploadedMasterDoc)}
          <Grid
            container
            sx={{
              justifyContent: 'flex-end',
            }}
          >
            <Button
              label={'UPLOAD'}
              variant="contained"
              height="37px"
              width="auto"
              disabled={false}
              onClick={uploadMasterDocument}
            />
          </Grid>
        </Grid>
      </Modal>
    );
  };

  const getTabsContent = () => {
    switch (tabIndex) {
      case 0:
        return UploadDocumentsTab();
      case 1:
        return <MergeDocumentsTab />;
      case 2:
        return ReportsTab();
      default:
        return <></>;
    }
  };

  //Onboarding Steps Content Component

  const ContractsUpload = () => {
    return (
      <>
        {contractLoading ? (
          <Loader height="505px" />
        ) : (
          <Grid className={classes.contractsUpload}>
            {(contractStep === 0 || contractStep === 1) && (
              <Grid style={{ marginBottom: '20px' }}>
                <TextWithIcon
                  startIcon={
                    contractStep !== 0 && (
                      <Back
                        cursor={'pointer'}
                        onClick={() => {
                          setContractStep((prevStep) => prevStep - 1);
                        }}
                      />
                    )
                  }
                  label={
                    <Typography
                      fontSize="16px"
                      fontType="semiBold"
                      lineHeight="24px"
                      textColor={patientAccessTheme.palette.text.highemphasis}
                    >
                      {messages.UPLOAD_CONTRACTS}
                    </Typography>
                  }
                />
              </Grid>
            )}
            {getContractStep()}
            <Grid className={classes.buttonsGrid}>
              {/* 
                <Button
                  label="Cancel"
                  variant="outlined"
                  height="37px"
                  width="auto"
                  onClick={() => {
                    setContractStep((prevStep) => prevStep - 1);
                  }}
                />
               */}
              <Button
                label={contractsButtonLabels[contractStep]}
                variant="contained"
                height="37px"
                width="auto"
                disabled={isContractsButtonDisabled}
                onClick={() => {
                  setContractStep((prevStep) => prevStep + 1);
                }}
              />
            </Grid>
          </Grid>
        )}
      </>
    );
  };

  const PlanDocumentsUpload = () => {
    return (
      <>
        {plansLoading ? (
          <Loader height="505px" />
        ) : (
          <Grid
            className={classes.contractsUpload}
            style={{
              padding:
                planDocsStep === 1
                  ? '25px 0px 28px 24px'
                  : '25px 24px 28px 24px',
            }}
          >
            {(planDocsStep === 0 || planDocsStep === 1) && (
              <Grid style={{ marginBottom: '20px' }}>
                <TextWithIcon
                  startIcon={
                    planDocsStep !== 0 && (
                      <Back
                        cursor={'pointer'}
                        onClick={() => {
                          setPlanDocsStep((prevStep) => prevStep - 1);
                        }}
                      />
                    )
                  }
                  label={
                    <Typography
                      fontSize="16px"
                      fontType="semiBold"
                      lineHeight="24px"
                      textColor={patientAccessTheme.palette.text.highemphasis}
                    >
                      {messages.UPLOAD_PLAN_DOCS}
                    </Typography>
                  }
                />
              </Grid>
            )}
            {getPlanDocumentStepContent()}
            <Grid className={classes.buttonsGrid}>
              {/* {planDocsStep === 1 && (
                <Button
                  label="Go Back"
                  variant="outlined"
                  height="37px"
                  width="auto"
                  onClick={() => {
                    setPlanDocsStep(planDocsStep - 1);
                  }}
                />
              )} */}
              <Button
                label={planDocsButtonLabels[planDocsStep]}
                variant="contained"
                height="37px"
                width="auto"
                disabled={isPlanDocsButtonDisabled}
                onClick={() => {
                  setPlanDocsStep(planDocsStep + 1);
                }}
              />
            </Grid>
          </Grid>
        )}
      </>
    );
  };

  const getStepContent = () => {
    switch (activeStep) {
      case 0:
        return completedSteps?.includes(0) ? (
          <ContractCompleted />
        ) : (
          <ContractsUploadTab
            egNid={egNid}
            employer={employer}
            openSnackbar={handleOpenSnackBar}
            onProceedClick={() => setContractStep(4)}
            onCreateContracts={() => setContractStep(2)}
          />
        );

      case 1:
        return completedSteps?.includes(1) ? (
          <PlanDocumentsCompleted />
        ) : (
          PlanDocumentsUpload()
        );
      default:
        return <></>;
    }
  };

  //Contracts onboard step components
  const UploadFiles = (
    uploadedFiles: any[],
    setUploadedFiles: React.Dispatch<any>,
  ) => {
    return (
      <>
        <Grid className={classes.uploadFilesGrid}>
          {uploadedFiles?.length > 0 && (
            <Grid className={classes.uploadedFiles}>
              <Typography
                fontSize="12px"
                fontType="regular"
                lineHeight="24px"
                textColor={patientAccessTheme.palette.text.lowemphasis}
                margin="0px 0px 16px 0px"
              >
                {`${uploadedFiles?.length} Document${
                  uploadedFiles?.length > 1 ? 's' : ''
                } uploaded`}
              </Typography>
              <Grid className={classes.files}>
                {uploadedFiles?.map((item: any, index: number) => {
                  return (
                    <UploadedDocument
                      name={item?.name}
                      size={`${bytesToMB(item?.size)} MB`}
                      handleDelete={() => {
                        const updatedItems = [...uploadedFiles];
                        // Remove the item at the specified index
                        updatedItems.splice(index, 1);
                        // Update the state with the new array
                        setUploadedFiles(updatedItems);
                      }}
                      width="100%"
                      truncateWidth="300px"
                    />
                  );
                })}
              </Grid>
            </Grid>
          )}
          <FileDropZone
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            filesSupported={['.pdf']}
            width={uploadedFiles?.length > 0 ? '38%' : '100%'}
            height="233px"
            isMultiple={tabIndex === 0}
          />
        </Grid>
        <InfoBar info={messages.UPLOAD_INFO} type={'Info'} width="100%" />
      </>
    );
  };

  const ContractSelections = () => {
    return (
      <Grid>
        <Grid className={classes.contractLabels}>
          {getTypography(
            `${uploadedDocuments?.length} Documents uploaded`,
            true,
            '233px',
          )}
          {getTypography(messages.CONTRACT_LABELS[0], false, '50px')}
          {getTypography(messages.CONTRACT_LABELS[1], false, '84px')}
          {getTypography(messages.CONTRACT_LABELS[2], false, '86px')}
          {getTypography(messages.CONTRACT_LABELS[3], false)}
        </Grid>
        <Grid className={classes.contractDocs}>
          {uploadedDocuments?.map((item, index: number) => {
            return (
              <Grid className={classes.eachContractDoc}>
                <UploadedDocument
                  name={item?.document_name}
                  size={''}
                  handleDelete={() => {
                    const updatedItems = [...uploadedDocuments];
                    // Remove the item at the specified index
                    updatedItems.splice(index, 1);
                    // Update the state with the new array
                    setUploadedDocuments(updatedItems);
                  }}
                  width="350px"
                  truncateWidth="265px"
                />
                <TypableDropdown
                  placeholder={'Select'}
                  dropDownOptions={serviceAgreements?.map(
                    (item: any) => item?.service_agreement_name,
                  )}
                  dropDownValues={serviceAgreements?.map(
                    (item: any) => item?._id,
                  )}
                  value={item?.service_agreement_id}
                  handleChange={(event) =>
                    handleChange(
                      event,
                      'service_agreement_id',
                      item?.document_id,
                    )
                  }
                  height="40px"
                  width="179px"
                  handleInputChange={() => {}}
                  hideTextField={true}
                />
                <TypableDropdown
                  dropDownOptions={healthcarePartners}
                  dropDownValues={healthcarePartners}
                  placeholder={'Select'}
                  textFieldPlaceholder="Enter Healthcare Partner name"
                  value={item?.health_care_partner}
                  handleChange={(event) =>
                    handleChange(
                      event,
                      'health_care_partner',
                      item?.document_id,
                    )
                  }
                  handleInputChange={(value) =>
                    handleInputChange(value, item?.document_id)
                  }
                  height="40px"
                  width="179px"
                  disabled={item?.service_agreement_id === ''}
                />
                <TypableDropdown
                  placeholder={'Select'}
                  dropDownOptions={messages.DOC_TYPE_OPTIONS}
                  dropDownValues={messages.DOC_TYPE_OPTIONS}
                  value={item?.document_type}
                  handleChange={(event) =>
                    handleChange(event, 'document_type', item?.document_id)
                  }
                  height="40px"
                  width="165px"
                  handleInputChange={() => {}}
                  hideTextField={true}
                />
                <DatePicker
                  selectedDate={formatDate(
                    item?.document_effective_date,
                    'MM-DD-YYYY',
                  )}
                  handleChange={(date, value) =>
                    handleDateChange(
                      value,
                      'document_effective_date',
                      item?.document_id,
                    )
                  }
                  height="40px"
                  width="138px"
                  minDate={undefined}
                  maxDate={undefined}
                  format="MM-dd-yyyy"
                  placeholder="mm-dd-yyyy"
                />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    );
  };

  const Contracts = () => {
    return (
      <>
        <Typography
          fontSize="14px"
          fontType="semiBold"
          lineHeight="24px"
          textColor={patientAccessTheme.palette.text.highemphasis}
        >
          {messages.CONTRACTS.TITLE}
        </Typography>
        <Typography
          fontSize="12px"
          fontType="regular"
          lineHeight="24px"
          textColor={patientAccessTheme.palette.text.mediumemphasis}
          margin="0px 0px 20px 0px"
        >
          {messages.CONTRACTS.SUB_TITLE}
        </Typography>
        <Grid className={classes.contractsTable}>
          <ContractsTable
            rowsData={contractsTableData}
            columns={[
              'Healthcare Partner',
              'Service Agreement Type',
              'Total Files',
              'Effective Date',
            ]}
          />
        </Grid>
      </>
    );
  };

  const SelectReports = () => {
    return (
      <>
        <Typography
          fontSize="14px"
          fontType="semiBold"
          lineHeight="24px"
          textColor={patientAccessTheme.palette.text.highemphasis}
        >
          {messages.REPORTS.TITLE}
        </Typography>
        <Typography
          fontSize="12px"
          fontType="regular"
          lineHeight="24px"
          textColor={patientAccessTheme.palette.text.mediumemphasis}
          margin="0px 0px 20px 0px"
        >
          {messages.REPORTS.SUB_TITLE}
        </Typography>
        <Grid className={classes.contractsTable}>
          <ReportsSelectionTable
            rowsData={reportsTableData}
            setRowsData={setReportsTableData}
            columns={[
              'Healthcare Partner',
              'Service Agreement Type',
              'Analysis/Reports',
            ]}
          />
        </Grid>
      </>
    );
  };

  const ContractCompleted = () => {
    return (
      <Grid className={classes.completedState}>
        <GifWithLabels
          mainLabel={
            <Typography
              fontSize="14px"
              fontType="medium"
              lineHeight="24px"
              textColor={patientAccessTheme.palette.text.highemphasis}
              margin="32px"
            >
              {messages.COMPLETED_MESSAGE}
            </Typography>
          }
          subLabel={
            <Button
              label={'Start Again'}
              variant="contained"
              height="37px"
              width="auto"
              onClick={() => {
                setSelectedFiles([]);
                setCompletedSteps((prevSteps) =>
                  prevSteps.filter((step) => step !== 0),
                );
                setContractStep(0);
              }}
            />
          }
          gifUrl={contract}
        />
      </Grid>
    );
  };

  const getContractStep = () => {
    switch (contractStep) {
      case 0:
        return UploadFiles(selectedFiles, setSelectedFiles);
      case 1:
        return <ContractSelections />;
      case 2:
        return <Contracts />;
      case 3:
      case 4:
        return SelectReports();
      default:
        return <></>;
    }
  };

  //Plan Documents onboard step components
  const PlanDocumentsSelections = () => {
    return (
      <Grid>
        <Grid className={classes.contractLabels}>
          {getTypography(
            `${uploadedPlanDocuments?.length} Documents uploaded`,
            true,
            '142px',
          )}
          {getTypography(messages.PLAN_DOCS_LABELS[0], false, '122px')}
          {getTypography(messages.PLAN_DOCS_LABELS[1], false, '87px')}
          {getTypography(messages.PLAN_DOCS_LABELS[2], false, '168px')}
          {getTypography(messages.PLAN_DOCS_LABELS[3], false, '41px')}
          {getTypography(messages.PLAN_DOCS_LABELS[4], false)}
        </Grid>
        <Grid className={classes.contractDocs}>
          {uploadedPlanDocuments?.map((item, index: number) => {
            return (
              <Grid className={classes.eachContractDoc}>
                <UploadedDocument
                  name={item?.document_name}
                  size={''}
                  handleDelete={() => {
                    const updatedItems = [...uploadedPlanDocuments];
                    // Remove the item at the specified index
                    updatedItems.splice(index, 1);
                    // Update the state with the new array
                    setUploadedPlanDocuments(updatedItems);
                  }}
                  width="258px"
                  truncateWidth="180px"
                />
                <AutocompleteWithCheckBoxes
                  width="189px"
                  height="40px"
                  options={item?.benefit_types ?? []}
                  defaultValue={item?.benefit_types ?? []}
                  handleChange={(
                    event: any,
                    value: any,

                    reason: any,

                    details: any,
                  ) =>
                    handlePlanChange(value, 'benefit_types', item?.document_id)
                  }
                />
                <TypableDropdown
                  placeholder={'Select'}
                  dropDownOptions={[
                    'Summary Plan Description',
                    'Summary Of Benefits',
                  ]}
                  dropDownValues={['SPD', 'SOB']}
                  value={item?.document_type}
                  handleChange={(event) =>
                    handleChangePlanDocs(
                      event,
                      'document_type',
                      item?.document_id,
                    )
                  }
                  height="40px"
                  width="128px"
                  handleInputChange={() => {}}
                  hideTextField={true}
                />
                <AutocompleteWithCheckBoxes
                  width="189px"
                  height="40px"
                  options={planNames ?? []}
                  defaultValue={item?.plan_names ?? []}
                  handleChange={function (
                    event: any,
                    value: any,

                    reason: any,

                    details: any,
                  ) {
                    handlePlanChange(value, 'plan_names', item?.document_id);
                  }}
                />
                <TypableDropdown
                  placeholder={'Select'}
                  dropDownOptions={messages.DOC_TYPE_OPTIONS}
                  dropDownValues={messages.DOC_TYPE_OPTIONS}
                  value={item?.document_sub_type}
                  handleChange={(event) =>
                    handleChangePlanDocs(
                      event,
                      'document_sub_type',
                      item?.document_id,
                    )
                  }
                  height="40px"
                  width="128px"
                  handleInputChange={() => {}}
                  hideTextField={true}
                />
                <DatePicker
                  selectedDate={formatDate(item?.effective_date, 'MM-DD-YYYY')}
                  handleChange={(date, value) =>
                    handlePlanDocsDateChange(
                      value,
                      'effective_date',
                      item?.document_id,
                    )
                  }
                  height="40px"
                  width="128px"
                  minDate={undefined}
                  maxDate={undefined}
                  placeholder="mm-dd-yyyy"
                  format="MM-dd-yyyy"
                />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    );
  };

  const PlanDocuments = () => {
    return (
      <>
        <Typography
          fontSize="14px"
          fontType="semiBold"
          lineHeight="24px"
          textColor={patientAccessTheme.palette.text.highemphasis}
        >
          {messages.PLAN_DOCS.TITLE}
        </Typography>
        <Typography
          fontSize="12px"
          fontType="regular"
          lineHeight="24px"
          textColor={patientAccessTheme.palette.text.mediumemphasis}
          margin="0px 0px 20px 0px"
        >
          {messages.PLAN_DOCS.SUB_TITLE}
        </Typography>
        <Grid className={classes.contractsTable}>
          {planDocsTableData?.length > 0 ? (
            <CustomTable
              columns={planDocsColumns}
              subColumns={[
                {
                  header: 'Doc Name',
                  accessor: 'docName',
                },
                {
                  header: 'Doc Type',
                  accessor: 'docType',
                },
                {
                  header: 'Effective Date',
                  accessor: 'effectiveDate',
                },
              ]}
              rowsData={planDocsTableData}
            />
          ) : (
            <NoDataVisual
              content="No Plan Documents"
              width="100%"
              height="300px"
            />
          )}
        </Grid>
      </>
    );
  };

  const SelectPlanDocsReports = () => {
    return (
      <>
        <Typography
          fontSize="14px"
          fontType="semiBold"
          lineHeight="24px"
          textColor={patientAccessTheme.palette.text.highemphasis}
        >
          {messages.REPORTS.TITLE}
        </Typography>
        <Typography
          fontSize="12px"
          fontType="regular"
          lineHeight="24px"
          textColor={patientAccessTheme.palette.text.mediumemphasis}
          margin="0px 0px 20px 0px"
        >
          {messages.ADD_REPORTS}
        </Typography>
        <ReportsSelectionTable
          rowsData={planDocsReportsTableData}
          setRowsData={setPlanDocsReportsTableData}
          columns={['Benefit Types', 'Plan Names', 'Analysis/Reports']}
        />
      </>
    );
  };

  const PlanDocumentsCompleted = () => {
    return (
      <Grid className={classes.completedState}>
        <GifWithLabels
          mainLabel={
            <Typography
              fontSize="14px"
              fontType="medium"
              lineHeight="24px"
              textColor={patientAccessTheme.palette.text.highemphasis}
              margin="32px"
            >
              {messages.PLAN_DOCS_COMPLETED_MESSAGE}
            </Typography>
          }
          subLabel={
            <Button
              label={'Start Again'}
              variant="contained"
              height="37px"
              width="auto"
              onClick={() => {
                setSelectedPlanDocs([]);
                setCompletedSteps((prevSteps) =>
                  prevSteps.filter((step) => step !== 1),
                );
                setPlanDocsStep(0);
              }}
            />
          }
          gifUrl={contract}
        />
      </Grid>
    );
  };

  const getPlanDocumentStepContent = () => {
    switch (planDocsStep) {
      case 0:
        return UploadFiles(selectedPlanDocs, setSelectedPlanDocs);
      case 1:
        return <PlanDocumentsSelections />;
      case 2:
        return <PlanDocuments />;
      case 3:
        return SelectPlanDocsReports();
      default:
        return <></>;
    }
  };

  //Typography components
  const getTypography = (
    label: string,
    lowemphasis?: boolean,
    marginRight?: string,
  ) => {
    return (
      <Typography
        fontSize="12px"
        fontType="regular"
        lineHeight="24px"
        textColor={
          lowemphasis
            ? patientAccessTheme.palette.text.lowemphasis
            : patientAccessTheme.palette.text.highemphasis
        }
        margin={`0px ${marginRight} 0px 0px`}
      >
        {label}
      </Typography>
    );
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Grid className={classes.root}>
          <PageTitleAndSubTitle
            title={messages.ONBOARDING.TITLE}
            subTitle={messages.ONBOARDING.SUB_TITLE}
          />
          <TabSelection
            selectedTabIndex={tabIndex}
            setSelectedTabIndex={setTabIndex}
            tabList={messages.TABS}
          />
          <Grid className={classes.tabContent}>{getTabsContent()}</Grid>
        </Grid>
      )}
      {isPlanDocsPopupOpen && (
        <ConfirmationPopup
          icon={<PlanDocs width={'44px'} height={'44px'} />}
          title={messages.PLAN_DOCS_POP_UP.TITLE}
          subTitle={messages.PLAN_DOCS_POP_UP.SUBTITLE}
          handleCancel={() => {
            if (
              contractsWithAmendmentsCount > 0 ||
              planDocWithAmendmentsCount > 0
            ) {
              setIsMergeDocsPopupOpen(true);
            } else {
              navigate(ONBOARDINGSTATUS);
            }
            setIsPlanDocsPopupOpen(false);
          }}
          handleConfirm={() => {
            setCompletedSteps((prevSteps) => [...prevSteps, 0]);
            setActiveStep(1);
            setIsPlanDocsPopupOpen(false);
          }}
          cancelButtonLabel="Skip"
          saveButtonLabel="Proceed"
        />
      )}
      {isMergeDocsPopupOpen && (
        <ConfirmationPopup
          icon={<PlanDocs width={'44px'} height={'44px'} />}
          title={
            contractsWithAmendmentsCount > 0 && planDocWithAmendmentsCount > 0
              ? `${contractsWithAmendmentsCount} Contract${
                  contractsWithAmendmentsCount > 1 ? 's' : ''
                } & ${planDocWithAmendmentsCount} Plan Document${
                  planDocWithAmendmentsCount > 1 ? 's' : ''
                } `
              : contractsWithAmendmentsCount > 0
              ? `${contractsWithAmendmentsCount} Contract${
                  contractsWithAmendmentsCount > 1 ? 's' : ''
                } `
              : planDocWithAmendmentsCount > 0
              ? `${planDocWithAmendmentsCount} Plan Document${
                  planDocWithAmendmentsCount > 1 ? 's' : ''
                } `
              : '' + messages.MERGE_DOCS_POP_UP.TITLE
          }
          subTitle={messages.MERGE_DOCS_POP_UP.SUBTITLE}
          handleCancel={() => {
            setIsMergeDocsPopupOpen(false);
            navigate(ONBOARDINGSTATUS);
          }}
          handleConfirm={() => {
            setCompletedSteps((prevSteps) => [...prevSteps, 1]);
            setIsMergeDocsPopupOpen(false);
            getContracts();
            getPlanDocs();
            setTabIndex(1);
          }}
          count={0}
          cancelButtonLabel="Skip"
          saveButtonLabel="Merge"
        />
      )}
      {uploadMasterDocPopUp && <UploadDocumentModal />}
      <Snackbar
        {...snackbarState}
        vertical={'bottom'}
        horizontal={'right'}
        handleClose={handleCloseSnackBar}
      />
    </>
  );
});

export default ContractOnBoarding;
